import { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function ResetPassword() {
    const { token } = useParams();
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (password !== confirm) {
            toast.error("Passwords do not match");
            return;
        }
        if (password.length < 6) {
            toast.error("Password must be at least 6 characters");
            return;
        }
        setLoading(true);
        try {
            await api.post("/auth/reset-password", { token, new_password: password });
            toast.success("Password updated. Please sign in.");
            navigate("/login");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Reset failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-[80vh] flex items-center justify-center px-6 py-12" data-testid="reset-page">
            <div className="surface p-8 w-full max-w-md">
                <div className="flex items-center gap-2 mb-6">
                    <KeyRound className="w-4 h-4 text-accent" />
                    <span className="overline !text-zinc-400">Set new password</span>
                </div>
                <h1 className="font-heading text-3xl font-bold tracking-tight mb-1">Reset password</h1>
                <p className="text-sm text-zinc-500 mb-8">Choose a new password to sign in.</p>

                <form onSubmit={submit} method="post" className="space-y-5" autoComplete="on">
                    <div>
                        <label htmlFor="reset-password" className="block text-xs font-medium text-zinc-400 mb-2">New password</label>
                        <input
                            id="reset-password"
                            name="password"
                            type="password"
                            autoComplete="new-password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="surface-input"
                            data-testid="reset-password"
                            placeholder="At least 6 characters"
                        />
                    </div>
                    <div>
                        <label htmlFor="reset-confirm" className="block text-xs font-medium text-zinc-400 mb-2">Confirm password</label>
                        <input
                            id="reset-confirm"
                            name="password_confirm"
                            type="password"
                            autoComplete="new-password"
                            required
                            value={confirm}
                            onChange={(e) => setConfirm(e.target.value)}
                            className="surface-input"
                            data-testid="reset-confirm"
                            placeholder="Repeat password"
                        />
                    </div>
                    <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="reset-submit">
                        {loading ? "Updating..." : "Update password"}
                    </button>
                </form>

                <p className="mt-6 text-sm text-zinc-500">
                    <Link to="/login" className="text-accent hover:underline" data-testid="reset-back-login">Back to sign in</Link>
                </p>
            </div>
        </div>
    );
}
